import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
}

export const getListRewards = async (search: any = null, filter: Filter, page?: any) => {
  let url = `${API_URLS}/rewards?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter?.type) url += `filters${filter.field}=${filter.type}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailRewardsCatalog = async (id?: any) => {
  let url = `${API_URLS}/rewards/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListRewardsAll = async () => {
  let url = `${API_URLS}/rewards?populate=*`
  try {
    const response = await axios.get(url)
    const allRewards = response.data.data.map((e: any) => ({
      label: e.attributes.name,
      value: e.id,
    }))
    return Promise.resolve(allRewards)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailRewards = async (
  id?: any,
  search: any = null,
  filter: any = null,
  page?: any
) => {
  let url = `${API_URLS}/reward-details?populate=*&filters[reward][id]=${id}&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter) url += `filters[status][$eq]=${filter}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRewardsDetail = async (id?: any) => {
  try {
    if (id) {
      let url = `${API_URLS}/reward-details?populate=*&filters[reward][id]=${id}`
      const response = await axios.get(url)
      const allVoucher = response.data.data.map((e: any) => ({
        label: e.attributes.code,
        value: e.id,
      }))
      return Promise.resolve(allVoucher)
    }
    return []
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRewardsDetailById = async (id?: any) => {
  try {
    if (id) {
      let url = `${API_URLS}/reward-details/${id}?populate=*`
      const response = await axios.get(url)
      return Promise.resolve(response.data.data)
    }
    return []
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRewardsById = async (id: any) => {
  try {
    const response = await axios.get(`${API_URLS}/rewards/${id}?populate=*`)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postRewards = async (datas: any) => {
  let file = new FormData()
  file.append('files', datas.image)
  try {
    const responseUpload = await axios.post(`${API_URLS}/upload`, file)
    const idImage = responseUpload.data[0].id
    if (responseUpload.status === 200) {
      var data = {
        name: datas.rewards,
        point: datas.point,
        stock: datas.qty,
        image: idImage,
        type: datas.type,
        description: datas.description,
        code: datas.code,
      }
      const response = await axios.post<any>(`${API_URLS}/rewards`, {
        data: data,
      })
      return Promise.resolve(response.data.data)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postImportRewards = async ({data, id}: any) => {
  try {
    const response = await axios.post(`${API_URLS}/rewards/import/${id}`, data)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteRewardsById = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/rewards/${id}`)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postRewardsDetail = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/reward-details`, {
      data: datas,
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteRewardDetailById = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/reward-details/${id}?populate=*`)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putRewardsDetail = async (datas: any) => {
  try {
    var data = {
      expired_date: datas.form.expired_date,
      member: datas.form.member,
      reward: datas.form.reward,
      status: datas.form.status,
      code: datas.form.code,
    }
    const response = await axios.put<any>(`${API_URLS}/reward-details/${datas.id}`, {
      data: data,
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putRewards = async (datas: any) => {
  try {
    var data = {
      name: datas.form.rewards,
      point: datas.form.point,
      stock: datas.form.qty,
      type: datas.form.type,
      description: datas.form.description,
      code: datas.form.code,
    }
    const response = await axios.put<any>(`${API_URLS}/rewards/${datas.id}`, {
      data: data,
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListRewardsNotValue0 = async (filter: any = null) => {
  let url = `${API_URLS}/rewards?populate=*`
  try {
    const response = await axios.get(url)
    const allRewards = response.data.data.map((e: any) => ({
      label: e.attributes.name,
      value: e.id,
      stock: e.attributes.stock,
      point: e.attributes.point,
    }))
    return Promise.resolve(allRewards)
  } catch (error) {
    return Promise.reject(error)
  }
}
